var map = {
	"./default-0-default-mini.png": "5449",
	"./default-0-love-left-mini.png": "541e",
	"./default-1-default-mini.png": "34eb",
	"./default-1-love-left-mini.png": "d27f",
	"./default-2-default-mini.png": "8a65",
	"./default-2-love-left-mini.png": "f3ff7",
	"./my-select-default-mini.png": "02e1",
	"./my-select-love-left-mini.png": "f3c9",
	"./select-default-mini.png": "ff64",
	"./select-love-left-mini.png": "3f4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a503";